import styled from 'styled-components'
import { theme } from './../../common'
import { Link } from 'react-router-dom'
import { HashLink } from 'react-router-hash-link';
import { Nav, NavDropdown } from 'react-bootstrap'

export const StyledLink = styled(Link)`
    color: ${({isCurrentLocation}) => isCurrentLocation ? theme.pink : theme.white};
    font-weight: bold;
    margin: 0 10%;
    @media screen and (max-width: 992px) {
        margin: 0 5%;
    }
    &:hover {
        color: ${theme.pink};
        text-decoration: none;
    }
`

export const StyledHashLink = styled(HashLink)`
    color: #707070;
    &:hover {
        text-decoration: none;
    }
`

export const StyledNavDropdown = styled(NavDropdown)`
        .dropdown-item {
            color:#707070; 
            &:active, &:hover {
                background-color: ${theme.primary}!important;
                ${StyledHashLink} {
                    color: #FFF!important;
                }
            }
        }
    .dropdown-toggle {
        color: ${({isCurrentLocation}) => isCurrentLocation ? theme.pink : theme.white}!important;
        padding: 0px;
        &:hover {
            color: ${theme.pink}!important;
            text-decoration: none;
        }
    }
`